export default "__VITE_ASSET__CiOHXES5__"